"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iterators = void 0;
const sdk_exporters_1 = require("@supernovaio/sdk-exporters");
/** Contains useful static data that can be iterated over */
class Iterators {
    /** All Supernova available token types */
    static allTokenTypes() {
        return [
            sdk_exporters_1.TokenType.color,
            sdk_exporters_1.TokenType.typography,
            sdk_exporters_1.TokenType.dimension,
            sdk_exporters_1.TokenType.size,
            sdk_exporters_1.TokenType.space,
            sdk_exporters_1.TokenType.opacity,
            sdk_exporters_1.TokenType.fontSize,
            sdk_exporters_1.TokenType.lineHeight,
            sdk_exporters_1.TokenType.letterSpacing,
            sdk_exporters_1.TokenType.paragraphSpacing,
            sdk_exporters_1.TokenType.borderWidth,
            sdk_exporters_1.TokenType.radius,
            sdk_exporters_1.TokenType.duration,
            sdk_exporters_1.TokenType.zIndex,
            sdk_exporters_1.TokenType.shadow,
            sdk_exporters_1.TokenType.border,
            sdk_exporters_1.TokenType.gradient,
            sdk_exporters_1.TokenType.string,
            sdk_exporters_1.TokenType.productCopy,
            sdk_exporters_1.TokenType.fontFamily,
            sdk_exporters_1.TokenType.fontWeight,
            sdk_exporters_1.TokenType.textCase,
            sdk_exporters_1.TokenType.textDecoration,
            sdk_exporters_1.TokenType.visibility,
            sdk_exporters_1.TokenType.blur
        ];
    }
    /** All Supernova available dimension token types */
    static allDimensionTokenTypes() {
        return [
            sdk_exporters_1.TokenType.dimension,
            sdk_exporters_1.TokenType.size,
            sdk_exporters_1.TokenType.space,
            sdk_exporters_1.TokenType.opacity,
            sdk_exporters_1.TokenType.fontSize,
            sdk_exporters_1.TokenType.lineHeight,
            sdk_exporters_1.TokenType.letterSpacing,
            sdk_exporters_1.TokenType.paragraphSpacing,
            sdk_exporters_1.TokenType.borderWidth,
            sdk_exporters_1.TokenType.radius,
            sdk_exporters_1.TokenType.duration,
            sdk_exporters_1.TokenType.zIndex
        ];
    }
    /** All Supernova available string token types */
    static allStringTokenTypes() {
        return [sdk_exporters_1.TokenType.string, sdk_exporters_1.TokenType.productCopy, sdk_exporters_1.TokenType.fontFamily, sdk_exporters_1.TokenType.fontWeight];
    }
    /** All Supernova available option token types */
    static allOptionTokenTypes() {
        return [sdk_exporters_1.TokenType.textCase, sdk_exporters_1.TokenType.textDecoration, sdk_exporters_1.TokenType.visibility];
    }
}
exports.Iterators = Iterators;
